export enum LayoutActionTypes {
	SENDMAIL = '[LAYOUT] - SENDMAIL',
}
